module.exports = __webpack_public_path__ + "media/images/emblems/Blason_commune_CH_Boulens_(Vaud)-4dc138c9068609ed09e054f20fae50be.svg";